import { useEffect, useState } from "react";
import "./Styles/commandsDetails.css";
import logoTest from "../Images/collection1.jpeg";
import moment from "moment/moment";
import { priceFr } from "../Services/Numbers";

export const CommandDetails = ({
  currentDetail = null,
  setCurrentDetail = null,
}) => {
  
  const productsURL = process.env.REACT_APP_API_BASE_URL+'/images/products/';
  const [showOrNot, setShoworNot] = useState(false);
  const [productList, setProductlist] = useState(<></>);
  
  useEffect(() => {
    if (currentDetail === null) {
      setShoworNot(false);
      return;
    } else {
      setShoworNot(true);
    }

    let TabList = [];
    let prodListApi = currentDetail.orderedProducts;

    prodListApi.forEach((element) => {
      let total = 0;
      if(element.product.discount){
        total = Math.round(element.product.price - (element.product.price*element.product.discount/100))
      }
      else {
        total = element.product.price
      }

      total *= element.quantity

      TabList.push(
        <a href={'/boutique/'+element.product.slug}>
          <div className='left-side-product'>
            <img src={productsURL+element.product.thumb} alt='logo-prod' />
            <div className='left-side-info'>
              <span>{element.product.name}</span>
              <div>
                <div className='quantity-nbrs'>
                  <span>Quantité</span>
                  <span>{element.quantity}</span>
                </div>
                <span>Total: {total}</span>
              </div>
            </div>
          </div>
        </a>
      );
    });

    setProductlist(TabList)
  }, [currentDetail]);
  
  function CloseMenu() {
    setCurrentDetail(null);
  }

  return (
    <div
      style={
        showOrNot
          ? { opacity: 1, pointerEvents: "all", zIndex: "15" }
          : { opacity: 0, pointerEvents: "none", zIndex: "0" }
      }
      className='command-detail'
    >
      {
        currentDetail !== null ? (
          <div className='container-command-detail'>
        <button onClick={CloseMenu}>X</button>
        <div className='title-cmd-details'>
          <span>ID: {currentDetail.Code} </span>
          <span>( {moment(currentDetail.confirmedAt).format("DD/MM/YYYY HH:mm:ss")} )</span>
        </div>
        <div className='product-info-command'>{productList}</div>
        <div className='bottom-info-pay'>
          <div>
            <span>Moyen de paiement :</span>
            <span>{currentDetail.paymentMethod.name}</span>
          </div>
          <div>
            <span>Zone de livraison :</span>
            <span>{currentDetail.deliveryZone.zone}</span>
          </div>
          <div>
            <span>Frais de livraison :</span>
            <span>{priceFr(currentDetail.deliveryZone.price)} F</span>
          </div>
          <div>
            <span>Coût total:</span>
            <span>{priceFr(currentDetail.total)} F</span>
          </div>
        </div>
      </div>
        ) : ''
      }
    </div>
  );
};
